import { useSnapshot } from "valtio";
import { useEffect, useState } from "react";
import { state } from "../store";
import "./Config.css";

export default function Config() {
  const snap = useSnapshot(state);
  const [selectedQuality, setSelectedQuality] = useState("balanced");

  useEffect(() => {
    // Initialize local UI selection from persisted value or current state
    // This keeps the UI reflecting the next-start preference without changing runtime state
    try {
      const saved =
        typeof localStorage !== "undefined" &&
        localStorage.getItem("qualitySettings");
      setSelectedQuality(saved || snap.qualitySettings || "balanced");
    } catch (err) {
      setSelectedQuality(snap.qualitySettings || "balanced");
    }
  }, [snap.qualitySettings]);

  const isOpen = snap.openedPanel === "config";

  const handleOpen = () => {
    state.openedPanel = "config";
    // Refresh selection from persisted storage when opening the panel
    try {
      const saved =
        typeof localStorage !== "undefined" &&
        localStorage.getItem("qualitySettings");
      if (saved) setSelectedQuality(saved);
    } catch (err) {
      // Ignore storage access issues
    }
  };

  const handleClose = () => {
    state.openedPanel = null;
  };

  function handleChange(value) {
    // Persist selection only, do not change runtime quality state
    setSelectedQuality(value);
    try {
      if (typeof localStorage !== "undefined") {
        localStorage.setItem("qualitySettings", value);
      }
    } catch (err) {
      // Ignore storage errors (quota/privacy mode)
    }
  }

  return (
    <>
      {isOpen && (
        <div className="config-wrapper">
          <div className="panel about">
            <button className="close-button-panel" onClick={handleClose}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 6L6 18M6 6L18 18"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            <div className="quality-options">
              <div>
                <h1>Quality Settings</h1>
                <p>⚠️ These settings only apply when you restart the app.</p>
              </div>
              <label>
                <input
                  type="radio"
                  name="quality"
                  value="performance"
                  checked={selectedQuality === "performance"}
                  onChange={() => handleChange("performance")}
                />
                Performance
                <p>Disable post processing and lower dpr</p>
              </label>

              <label>
                <input
                  type="radio"
                  name="quality"
                  value="balanced"
                  checked={selectedQuality === "balanced"}
                  onChange={() => handleChange("balanced")}
                />
                Balanced
                <p>Post processing and default dpr</p>
              </label>

              <label>
                <input
                  type="radio"
                  name="quality"
                  value="ultra"
                  checked={selectedQuality === "ultra"}
                  onChange={() => handleChange("ultra")}
                />
                Ultra
                <p>SSGI + SSAO + Bloom + SSR</p>
              </label>
            </div>

            <div className="about-text">
              {selectedQuality !== snap.qualitySettings && (
                <button
                  className="refresh-button-panel"
                  onClick={() => {
                    // Force app reload to apply new quality setting from localStorage
                    try {
                      window.location.reload();
                    } catch (err) {
                      // Fallback: navigate to same URL
                      window.location.href = window.location.href;
                    }
                  }}
                >
                  Refresh to apply
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
